import React, { useState, useEffect } from "react";
import {
  CNavbar,
  CNavbarBrand,
  CContainer,
  CNavbarToggler,
  COffcanvas,
  COffcanvasHeader,
  COffcanvasTitle,
  CCloseButton,
  COffcanvasBody,
  CNavbarNav,
  CNavItem,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react-pro";
import { useTranslation } from "react-i18next";

import logo from "../assets/icon/logo.png";

function Navbar() {
  const [visible, setVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const currentLang = i18n.language?.split("-")[0] || "pt";

  const langLabels = { pt: "PT", en: "EN", es: "ES" };

  return (
    <CNavbar
      className={`py-4 navbarWhite ${scrolled ? "scrolled" : ""}`}
      expand="xl"
    >
      <div className="nav-container">
        <CContainer fluid>
          <CNavbarBrand className={`navLogo2`}>
            <a href="/">
              <img src={logo} alt="logo" width={200} />
            </a>
          </CNavbarBrand>
          <CNavbarToggler
            aria-controls="offcanvasNavbar2"
            aria-label="Toggle navigation"
            onClick={() => setVisible(!visible)}
          />
          <COffcanvas
            id="offcanvasNavbar2"
            placement="end"
            portal={false}
            visible={visible}
            onHide={() => setVisible(false)}
          >
            <COffcanvasHeader>
              <COffcanvasTitle></COffcanvasTitle>
              <CCloseButton
                className="text-reset"
                onClick={() => setVisible(false)}
              />
            </COffcanvasHeader>
            <COffcanvasBody>
              <div className="flex-content-nav">
                <CNavbarNav>
                  <CNavItem className={`px-1 homeLink`}>
                    <a href="/home" active reloadDocument>
                      {t("nav_home")}
                    </a>
                  </CNavItem>
                  <CNavItem className={`px-1 aboutLink`}>
                    <a href="/about" active reloadDocument>
                      {t("nav_about")}
                    </a>
                  </CNavItem>
                  <CNavItem className={`px-1 servicesLink`}>
                    <a href="/services" active reloadDocument>
                      {t("nav_services")}
                    </a>
                  </CNavItem>
                  <CDropdown
                    variant="btn-group"
                    className={`px-1 structureLink`}
                  >
                    <CDropdownToggle>{t("nav_structure")}</CDropdownToggle>
                    <CDropdownMenu>
                      <CDropdownItem>
                        <a href="/warehouseStructure" reloadDocument>
                          {t("nav_warehouse")}
                        </a>
                      </CDropdownItem>
                      <CDropdownItem>
                        <a href="/fleetStructure" reloadDocument>
                          {t("nav_fleet")}
                        </a>
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                </CNavbarNav>
                <CNavbarBrand className={`navLogo`}>
                  <img src={logo} alt="logo" width={230} />
                </CNavbarBrand>
                <CNavbarNav>
                  <CNavItem className={`px-1 careerLink`}>
                    <a href="/career" active reloadDocument>
                      #{t("nav_career")}
                    </a>
                  </CNavItem>
                  <CNavItem className={`px-1 contactLink`}>
                    <a href="/contact" active reloadDocument>
                      {t("nav_contact")}
                    </a>
                  </CNavItem>
                  <CNavItem className={`px-1 esgLink`}>
                    <a href="/esg" active reloadDocument>
                      {t("nav_esg")}
                    </a>
                  </CNavItem>
                  <CNavItem className={`px-1 blogLink`}>
                    <a href="/blog" active reloadDocument>
                      {t("nav_blog")}
                    </a>
                  </CNavItem>
                  <CDropdown variant="btn-group" className="langLink langLinkDesktop">
                    <CDropdownToggle className="langToggle">
                      {langLabels[currentLang] || "PT"}
                    </CDropdownToggle>
                    <CDropdownMenu>
                      <CDropdownItem onClick={() => changeLanguage("pt")} className={currentLang === "pt" ? "lang-active" : ""}>
                        Português
                      </CDropdownItem>
                      <CDropdownItem onClick={() => changeLanguage("en")} className={currentLang === "en" ? "lang-active" : ""}>
                        English
                      </CDropdownItem>
                      <CDropdownItem onClick={() => changeLanguage("es")} className={currentLang === "es" ? "lang-active" : ""}>
                        Español
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                  <CDropdown variant="btn-group" className="portalLink2">
                    <CDropdownToggle>{t("nav_portals")}</CDropdownToggle>
                    <CDropdownMenu>
                      <CDropdownItem href="http://portal.ghlogistica.com.br:8081/view/rastreamento/RastreioPedidoSimplesTransporte.php">
                        {t("nav_cargo_tracking")}
                      </CDropdownItem>
                      <CDropdownItem href="http://portal.ghlogistica.com.br:8081/view/estrutura/login.php">
                        {t("nav_client_portal")}
                      </CDropdownItem>
                      <CDropdownItem href="https://ghconecta.ghlogistica.com.br">
                        GHConecta
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                  <div className="langLinkMobile">
                    <button
                      onClick={() => changeLanguage("pt")}
                      className={currentLang === "pt" ? "lang-active" : ""}
                    >
                      Português
                    </button>
                    <button
                      onClick={() => changeLanguage("en")}
                      className={currentLang === "en" ? "lang-active" : ""}
                    >
                      English
                    </button>
                    <button
                      onClick={() => changeLanguage("es")}
                      className={currentLang === "es" ? "lang-active" : ""}
                    >
                      Español
                    </button>
                  </div>
                </CNavbarNav>
              </div>
            </COffcanvasBody>
          </COffcanvas>
        </CContainer>
      </div>
    </CNavbar>
  );
}

export default Navbar;
